import React from "react";
import { Car } from "../../services/mobile";
import styled from "styled-components";
import CarItem from "../CarItem";

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

interface Props {
  cars: Car[];
  onClickCar: (carId: Car["id"]) => any;
}
const CarList = ({ cars, onClickCar }: Props) => {
  return (
    <Wrapper>
      {cars.map((car) => (
        <CarItem key={car.id} car={car} onClickCar={onClickCar} />
      ))}
    </Wrapper>
  );
};

export default CarList;
